import {
  Button,
  Drawer,
  Skeleton,
  Checkbox,
  TreeSelect,
  Card,
  Spin,
  ConfigProvider,
  Radio,
  Space,
  Tag,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../../Elements/TreeSelect/TreeSelectCustom";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useDispatch, useSelector } from "react-redux";
import * as echarts from "echarts";
import TreeSelectCustomWithSelectAll from "./TreeSelectCustomWithAllSelect";
import {
  EnvironmentOutlined,
  FilterOutlined,
  // SunOutlined,
} from "@ant-design/icons";
import Empty from "../../../../../../CommonScreens/Empty";
import { setTheme } from "../../../../../../../Store/Reducers/ThemeAction";
import CustomThemeDrawer from "../../../../../../Elements/CustomThemeDrawer";
import { handledarkMode } from "../../../../../../Elements/DarkModeAction";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";
import NotAuthenticated from "../../../../../../CommonScreens/NotAuthenicated";

const LiveChart = () => {
  const chartRef = useRef(null); 
  const chartInstance = useRef(null);
  const prevSeriesRef = useRef([]);
  const prevTimestampsRef = useRef([]);
   
  const { loading, makeRequest,screenNameChecker } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState(["VLLAvg","KWT"]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [openTheme, setOpenTheme] = useState(false);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);
  const [steamHistoricalData, setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter, setParameter] = useState([]);
  const [data1, setData1] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [loadings, setLoadings] = useState(true);
  const [loadingss, setLoadingss] = useState(true);
  const [inputLiveData, setInputLiveData] = useState([]);
  const [defaultLoad, setDefaultLoad] = useState(true);
  const [legends,setLegends]= useState([])
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 1000); // 2 seconds
  };
  useEffect(() => {
    simulateLoading(setLoadings);
  }, []);

  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color);
  const { isdarkMode } = mode;

  useEffect(() => {
    console.log(localStorage.getItem("LiveTrendsselectedMeterIds"))
   
  }, []);
  useEffect(() => {
    localStorage.setItem("LiveTrendssectionId", 1);
    localStorage.setItem("LiveTrendsconverterGroupId", 1)
    // setConverterGroupId(1);
    //  [ 'KWT', 'VLLAvg' ]
     localStorage.setItem("LiveTrendsselectedValues", JSON.stringify([ 'KWT', 'VLLAvg' ]));
      return () => {
      console.log("Component unmounted — clearing localStorage");
      localStorage.removeItem("LiveTrendsselectedMeterIds");
      localStorage.removeItem("LiveTrendssectionId");
      localStorage.removeItem("LiveTrendsconverterGroupId");
      localStorage.removeItem("LiveTrendsselectedValues");
    };
  }, []);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setgetFlowConverterResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
      }
    });
  }, []);

  useEffect(() => {
    if (sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
      }).then((res) => {
        //  //console.log(res);
        if (res && res.length > 0) {
          setflowGroupDetailsResData(res);
        }
      });
    }
  }, [sectionId]);



  useEffect(() => {
    if (converterGroupId && sectionId == 1) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meterid);

            //console.log(res.map((meter) => meter.meterid));
            // console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("LiveTrendsselectedMeterIds", firstFiveMeters);
            setDefaultLoad(false);
          }
          setnsGetFlowConverterResData(res);
        }
      });
    }

    if (converterGroupId && sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowSteamGroupMeterResData(res);
        }
      });
    }
  }, [converterGroupId]);

  function prepareLineChartData(
  data,
  toDate,
  fromDate,
  excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]
) {
  const series = [];
  const metrics = {};
  const parameters = [];

  // Normalize date string
  const normalizeDateString = (str) => {
    const parts = str.split("T");
    const [y, m, d] = parts[0].split("-");
    const paddedDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    return `${paddedDate}T${parts[1]}`;
  };

  const start = new Date(normalizeDateString(fromDate));
  const end = new Date(normalizeDateString(toDate));

  // Format timestamp (yyyy-mm-dd hh:mm:00)
  const formatTs = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:00`;
  };

  // Generate all timestamps
  const allTimestamps = [];
  let current = new Date(start);
  while (current <= end) {
    allTimestamps.push(formatTs(current));
    current.setMinutes(current.getMinutes() + 1);
  }

  // If data is empty, just return timestamps (no series)
  if (!data || data.length === 0) {
    return {
      xAxisData: allTimestamps,
      series: [],        // ✅ no fake series
      parameter: [],
    };
  }

  // Process available data
  data.forEach((entry) => {
    const createdOn = new Date(entry.CreatedOn);
    if (createdOn >= start && createdOn <= end) {
      const formattedTs = formatTs(createdOn);
      for (const key in entry) {
        if (!excludeFields.includes(key)) {
          const metricKey = `${entry.METERNAME}-${key}`;
          if (!metrics[metricKey]) {
            metrics[metricKey] = {};
          }
          metrics[metricKey][formattedTs] = entry[key];
          parameters.push(key);
        }
      }
    }
  });

  // Build chart series
  for (const [metricName, valuesByTs] of Object.entries(metrics)) {
    const filledValues = allTimestamps.map(
      (ts) => valuesByTs[ts] ?? ""
    );
    series.push({
      name: metricName,
      type: "line",
      data: filledValues,
    });
  }

  return {
    xAxisData: allTimestamps,
    series,
    parameter: [...new Set(parameters)],
  };
}

  const getResponse = (inputData) => {
    console.log(inputData);
    //console.log(open);
    setIsLoading(true);
    if (
      inputData &&
      inputData?.SectionID &&
      inputData?.ConverterorGroupID &&
      inputData?.MeterIds &&
      inputData.MeterIds.length &&
      inputData.Parameters &&
      !open
    ) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_LIVE_CHART}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`,
      }).then((res) => {
        console.log(res);
        // if (res && res.length > 0) {
          setsteamHistoricalData(res);
          // const data = transformDatas(res);
          // //console.log(data);
          setData(res);
          // //console.log(data.meterNames);
          // setData1(data.createdOn)
          // setData2(data.series)
          // setData3(data.meterNames)
          const test = prepareLineChartData(res,inputData.ToDate.replace(".000Z",""),inputData.FromDate.replace(".000Z",""));
          console.log(test);
          setData1(test.xAxisData);
          setData2(test.series);
          setLoadingss(false);
          setRefetch(true);
          // insertData(test.xAxisData, test.series)
          // setData3(test.parameter)
        // }
        setIsLoading(false);
      });
    }
  };

  useEffect(() => {
    if (inputLiveData) {
      getResponse(inputLiveData);
    }
  }, [inputLiveData]);

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    localStorage.setItem("LiveTrendssectionId", changedValues);
    localStorage.setItem("LiveTrendsconverterGroupId", "");
    // localStorage.setItem("LiveTrendsselectedMeterIds", null);
    setSectionId(changedValues);
    setConverterGroupId();
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    localStorage.setItem("LiveTrendsconverterGroupId", changedValues);
    localStorage.setItem("LiveTrendsselectedMeterIds", null);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    // //console.log(selectedValues)
    localStorage.setItem("LiveTrendsselectedMeterIds",selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    //console.log(values)
    localStorage.setItem("LiveTrendsselectedValues", JSON.stringify(values));

    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    // setOpen(false);
    const sectionId = localStorage.getItem("LiveTrendssectionId");
    // //console.log(sectionId);
    const converterGroupId = localStorage.getItem("LiveTrendsconverterGroupId");
    // //console.log(converterGroupId);
    const selectedValue = localStorage.getItem("LiveTrendsselectedValues");
    //console.log(selectedValue);
    const para = JSON.parse(selectedValue)
      ?.map((id) => id)
      .join(",");
    // //console.log(para);
    const selectedMeterId = localStorage.getItem("LiveTrendsselectedMeterIds");
    // console.log(selectedMeterId);
    // console.log(selectedMeterIds);
    // console.log(selectedMeterIds.join(','));
    let ids = [];
    // if(selectedMeterIds!=''&&selectedMeterIds!=null){
    //   ids = JSON.parse(selectedMeterIds||'1,2,3,4,5,6,7,8,9,10,11,12')
    //     ?.map((id) => id)
    //     .join(",");
    // }
    // //console.log(ids);
    // setSelectedMeterIds(JSON.parse(selectedMeterIds));
    // setSelectedValues(JSON.parse(selectedValue));

        sectionId == 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
                console.log(para)
                console.log(selectedMeterIds)
                console.log(nsGetFlowConverterList)
                console.log(getFlowSteamGroupMeterList)

const paramArr = para.split(',');

// Build legends
const legendsData = selectedMeterIds.flatMap(id => {
  const meter = sectionId == 1
                ? nsGetFlowConverterList.find(m => m.meterid == id)
                : getFlowSteamGroupMeterList.find(m => m.meterid == id);
  return meter ? paramArr.map(p => `${meter.metername}-${p}`) : [];
});

console.log(legendsData);
if(legendsData.length){
  localStorage.setItem("legends", JSON.stringify(legendsData))
}
// console.log(legendsData.pop());
// localStorage.setItem()
setLegends(legendsData)
    const currentDate = new Date();
    // //console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 60, 0);
    // //console.log(from, to);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 0,
      Parameters: para || 0,
      MeterIds: selectedMeterId ||selectedMeterIds.join(',') ,
      // FromDate: '2023-08-03 12:32:53',
      // ToDate: '2023-08-03 12:52:53',
      FromDate: from,
      ToDate: to,
    };
    // //console.log(inputData);
    setRefetch(true);
    setInputLiveData(inputData);
    // getResponse(inputData);
    // onClose()
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    // Call the function every minute
    //console.log(refetch);
    const interval = setInterval(() => {
      //console.log(refetch);
      if (refetch) {
      }
      setChartInputData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setChartInputData();
  }, [defaultLoad]);
  useEffect(() => {
    setChartSkip(!chartSkip);
    // updateChart();
  }, [steamHistoricalData]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
    //console.log(sectionError, converterError, meterError, paraError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();

      setIsLoading(!isLoading);
    }
  };

  useEffect(() => {
    if (loading || !data1 || !data2 || data1.length === 0 )
      return;

    const chart = chartInstance.current || echarts.init(chartRef.current);
    chartInstance.current = chart;
    const legends = JSON.parse(localStorage.getItem("legends")) || [];
    console.log(legends)

console.log(legends);
    console.log(data2) 
    console.log(data1) 
    const currentMeters = legends.map((s) => s);
    console.log(currentMeters)
    const previousMeters = (prevSeriesRef.current || []).map((s) => s);
    console.log(previousMeters)

    const removedMeters = previousMeters.filter(
      (m) => !currentMeters.includes(m)
    );
    const addedMeters = currentMeters.filter(
      (m) => !previousMeters.includes(m)
    );

    const themeColor = isdarkMode ? "#2d3748" : "#ffffff";
    const textColor = isdarkMode ? "#ffffff" : "#000000";

    const combinedTimestamps = data1.slice(-60);

    const baseOption = {
      backgroundColor: themeColor,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "line",
          label: { show: true, backgroundColor: "#6a7985" },
        },
        backgroundColor: themeColor,
        textStyle: { color: textColor },
        confine: true,
        extraCssText: "box-shadow: 0 0 5px rgba(0,0,0,0.3);",
      },
      // legend: {
      //   top: "0px",
      // }
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {
            show: true,
            title: "Download",
            pixelRatio: 2, // higher resolution
            name: "chart-image", // file name
          },
        },
      },
      legend: {
        textStyle: { color: textColor },
        type: "scroll",
        top: "0%",
        orient: "horizontal",
        left: "center", // Centers the legend
        itemGap: 10, // Adjust spacing between items
        padding: [5, 20], // Optional padding
        width: "80%", // Prevents it from taking full width
      },
      dataZoom: [
        {
          type: "slider", // Bottom zoom bar
          show: true,
          xAxisIndex: 0,
          start: 0, // Initial window start %
          end: 100, // Initial window end %
        },
        {
          type: "inside", // Scroll/drag zoom
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],
      grid: {
        left: "3%",
        right: "4%",
        bottom: "15%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: combinedTimestamps,
          axisLabel: {
            color: textColor,
            fontSize: 10,
            fontWeight: "bold",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            color: textColor,
            fontSize: 10,
            fontWeight: "bold",
          },
        },
      ],
    };

    if (
      addedMeters.length > 0 ||
      removedMeters.length > 0 ||
      !prevSeriesRef.current.length
    ) {
      
      const fullSeries = data2.map((series) => ({
        ...series,
        data: series.data.slice(-60), // ✅ align with 15 timestamps
      }));
      const dat = legends.map(meter => { 
        const found = fullSeries.find(s => s.name === meter); return found ? found : { name: meter, type: "bar", data: [] }; }) 
      console.log(legends)
       console.log(dat)

      chart.setOption(
        { ...baseOption, series: dat },
        { notMerge: true }
      );
    } else {
      const updatedSeries = data2.map((series) => ({
        ...series,
        data: series.data.slice(-60), //  only last 15 data points
      }));
const dat = legends.map(meter => { 
  const found = updatedSeries.find(s => s.name === meter); return found ? found : { name: meter, type: "bar", data: [] }; }) 
  console.log(legends) 
  console.log(dat)
      chart.setOption({
        xAxis: [{ data: combinedTimestamps }],
        series: dat,
        backgroundColor: themeColor,
      });
    }

    prevSeriesRef.current = JSON.parse(JSON.stringify(data2));
    prevTimestampsRef.current = [...combinedTimestamps];

    const resizeHandler = () => chartInstance.current?.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [data1, data2, loading, isdarkMode]);

  return (
    <div
      id="chart"
      className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      <div className="flex justify-between items-center px-2">
        <div className="text-3xl">
          <h4
            className={`text-left text-[20px] md:text-[30px] mb-5 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            LIVE TRENDS 
          </h4>
        </div>
        <div className=" flex gap-5">
              <Tag className="animated-tag w-24 text-lg">
            <EnvironmentOutlined className="mr-1" />
            Live
          </Tag>
          <Button
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            onClick={() => setOpen(true)}
          >
            <FilterOutlined /> Filter
          </Button>
        </div>
        {/* <Button
          role="primary"
          size="large"
          className="flex justify-center items-center "
          onClick={() => setOpen(!open)}
        >
          <FilterOutlined /> Filter
        </Button> */}
      </div>

      {
        !data1.length > 0 && !loading && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      }
      <Card
        className={`p-4 rounded-md shadow dark ${isdarkMode ? "darkmode" : "whitemode  "} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{
          position: "relative",
          overflow: "hidden",
          // background: isdarkMode ? "" : color.themeConfig.colorPrimaryShade,
        }}
        bordered={false}
      >
        {loading && loadings && (
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
        )}
        <div
          ref={chartRef}
          className={`${(!loading || !loadings) && data1.length > 0 ? "min-h-[80vh]" : "h-0"}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}
        />
      </Card>

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId == 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={"meterid"}
            valueKey={"meterid"}
            nameKey={"metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Parameters:"
            data={parameter}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parametername"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type="primary"
            className=""
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default LiveChart;
